import { Tooltip, validateBinding } from './lib'
import type { ToolTipOptionsInput, TargetElement } from './lib'
import type { DirectiveBinding } from 'vue'

import './tooltip.scss'

export default {
  beforeMount(
    el: TargetElement,
    binding: DirectiveBinding<ToolTipOptionsInput>,
  ): void {
    if (!validateBinding(binding)) {
      return
    }

    el.__tooltip = new Tooltip(el, binding.value)
    el.__tooltip.addTriggerListeners()
  },

  updated(
    el: TargetElement,
    binding: DirectiveBinding<ToolTipOptionsInput>,
  ): void {
    if (!validateBinding(binding) || !el.__tooltip) {
      return
    }
    el.__tooltip.setOptions(binding.value)
  },

  unmounted(el: TargetElement): void {
    if (!el.__tooltip) {
      return
    }
    el.__tooltip.removeTriggerListeners()
    delete el.__tooltip
  },
}
